module.exports = __webpack_public_path__ + "resources/icon-v-orange.3d29216509820610.png";


//////////////////
// WEBPACK FOOTER
// ../src/ui/avatar/img/icon-v-orange.png
// module id = 409
// module chunks = 0 1 2 3 4